'use strict';

var _ = require('underscore'),
    config = require('config'),
    parseHostname = require('./parseHostname'),
    { soundCloudThumbnailProxyUrl } = require('config');

var resizerBaseUrl = config.resizerBaseUrl;
if (!resizerBaseUrl) {
  throw new Error('You forgot to pass resizerBaseUrl as config parameter.');
}

var STORAGE_HOSTS = ['stampsy-eu-1.s3.amazonaws.com'];

function formatUrl(format, params, query) {
  var url = format,
      queryStr;

  _.each(params, (val, key) => {
    url = url.replace(RegExp('{' + key + '}', 'g'), val);
  });

  queryStr = _.chain(query)
    .map((val, key) => !_.isUndefined(val) && key + '=' + val)
    .compact().value().join('&');

  return queryStr ? url + '?' + queryStr : url;
}

function getThumbnailUrl(image, options) {
  var url = image && image.url,
      resizeHash = image && image.resizeHash;

  if (!url) {
    if (!options.allowEmpty) {
      throw new Error('Bad original url');
    }

    return;
  }

  var isExternal = !_.contains(STORAGE_HOSTS, parseHostname(url));
  if (options.allowExternal && isExternal) {
    return url;
  }

  if (!options.width && !options.height) {
    throw new Error('Either width or height is required');
  }

  var query = _.pick(options, ['quality', 'blur']);

  if (resizeHash) {
    query.resizeHash = resizeHash;

    // SoundCloud URLs aren't always valid, -original may be missing.
    // We need to run them through a proxy.

    if (url.indexOf('sndcdn.com') !== -1) {
      url = soundCloudThumbnailProxyUrl + url;
    }
  }

  if (url.indexOf('http://') === 0) {
    url = url.substring('http://'.length);
  }

  if (url.indexOf('https://') === 0) {
    url = url.substring('https://'.length);
  }

  var params = {
    baseUrl: resizerBaseUrl,
    mode: options.mode || 'preview',
    width: options.width || '',
    height: options.height || '',
    url: url
  };

  return formatUrl(
    '{baseUrl}/{mode}/{width}x{height}/{url}',
    params,
    query
  );
}

module.exports = getThumbnailUrl;


/** WEBPACK FOOTER **
 ** ./utils/getThumbnailUrl.js
 **/